import { Routes } from '@angular/router';
import { UserRole } from '@shared/types/user';
import { checkPermissionGuard } from '../guards/check-permission.guard';
import { loggedInAuthGuard } from '../guards/is-logged-in.guard';

export const MULTI_WHEEL_ROUTES: Routes = [
  {
    path: 'multi-wheel-theme',
    loadChildren: () =>
      import('./theme/theme.module').then((m) => m.MultiWheelThemeModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'multi-wheel-games',
    loadComponent: () =>
      import('./game/containers/game.component').then(
        (m) => m.MultiWheelGameComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
];
